import React, { ComponentType, PureComponent } from 'react';
import { ApplePayConfigurationContext } from '../services/ApplePayConfigurationContext';

const withApplePayConfigurationContext = <P extends object>(Component: ComponentType<P>) => {
  class WithApplePayConfigurationContext extends PureComponent<P> {
    render() {
      return (
        <ApplePayConfigurationContext.Consumer>
          {value => <Component {...this.props} {...value} />}
        </ApplePayConfigurationContext.Consumer>
      );
    }
  }

  return WithApplePayConfigurationContext;
};

export default withApplePayConfigurationContext;
